import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../utils/api';
import PhylogenyTree from './PhylogenyTree';

/**
 * The reference phylogeny on the DNA page: closed until asked for, fetched once.
 *
 * It is the baseline the bank's sequences will be aligned and placed against,
 * so it lives beside the sequencing runs rather than on a page of its own.
 */
export default function ReferencePhylogenyPanel() {
  const { t } = useTranslation('phylogeny');
  const [open, setOpen] = useState(false);
  const [state, setState] = useState({ status: 'idle', data: null });

  const toggle = () => {
    const next = !open;
    setOpen(next);
    if (next && state.status === 'idle') {
      setState({ status: 'loading', data: null });
      api.get('/phylogeny/reference')
        .then(({ data }) => setState({ status: 'ready', data }))
        .catch(err => setState({ status: err?.response?.status === 404 ? 'missing' : 'failed', data: null }));
    }
  };

  return (
    <section data-testid="reference-phylogeny" style={panelStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <div>
          <h3 style={{ margin: 0, fontSize: 16, color: 'var(--c-primary-fg)' }}>🌳 {t('title')}</h3>
          <p style={{ margin: '2px 0 0', fontSize: 12, color: 'var(--c-text-muted-fg)', maxWidth: 760 }}>{t('intro')}</p>
        </div>
        <button type="button" onClick={toggle} aria-expanded={open} style={buttonStyle}
          title={open ? t('tip.hideTree') : t('tip.showTree')}>
          {open ? t('hide') : t('show')}
        </button>
      </div>
      {open && (
        <div style={{ marginTop: 10 }}>
          {state.status === 'loading' && <p style={hint}>{t('loading')}</p>}
          {state.status === 'missing' && <p style={hint}>{t('notBuilt')}</p>}
          {state.status === 'failed' && <p style={{ ...hint, color: 'var(--c-danger-fg)' }}>{t('loadFailed')}</p>}
          {state.status === 'ready' && (
            <PhylogenyTree reference={state.data.reference} heldGenera={state.data.held_genera || {}} />
          )}
        </div>
      )}
    </section>
  );
}

const panelStyle = { background: 'var(--c-surface)', border: '1px solid var(--c-border)', borderRadius: 8, padding: 12, margin: '12px 0' };
const buttonStyle = { background: 'var(--c-primary)', color: 'var(--c-on-accent)', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', fontSize: 13 };
const hint = { fontSize: 13, color: 'var(--c-text-muted-fg)' };
